import { Alert, Autocomplete, Box, Button, List, ListItem, TextField, Typography } from "@mui/material";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { useTranslation } from "react-i18next";
import { colors } from "../../../theme/colors";
import * as yup from "yup";
import FormikErrorText from "../../../components/ui/FormikErrorText";
import { useEffect, useState } from "react";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { Urls } from "../../../api/Urls";
import Api from "../../../api/Api";
import Loading from "../../../components/ui/Loading";
const AjoutMarchand = () => {
  const [data, setData] = useState([]);
  const [limit, setLimit] = useState({ state: true, number: 10 });
  const [limitDbs, setLimitDbs] = useState({ state: true, number: 10 });
  const [loading, setLoading] = useState(true);
  const [franchise, setFranchise] = useState({ name: "", id: "" });
  const [error, setError] = useState("");
  const { user } = useAuthContext();
  const lang = localStorage?.getItem("i18nextLng");
  const [success, setSuccess] = useState("");
  const [bds, setBds] = useState([]);
  const access_token = user?.access;
  const { t } = useTranslation();
  const initial_values = {
    banniere: { name: "", id: "" },
    code_marchand: "",
    entreprise: "",
    responsable_first_name: "",
    responsable_last_name: "",
    adresse: "",
    ville: "",
    code_postal: "",
    telephone: "",
    courriel: "",
    payable_first_name: "",
    payable_last_name: "",
    payable_email: "",
    cellulaire: "",
    utilisateur: "",
    mot_de_passe: "",
    bd: { name: "", id: "" },
  };
  const validationSchema = yup.object({
    banniere: yup?.object({
      id: yup?.string().required(t("validation_required")),
    }),
    code_marchand: yup?.string().required(t("validation_required")),
    entreprise: yup?.string().required(t("validation_required")),
    responsable_first_name: yup?.string().required(t("validation_required")),
    responsable_last_name: yup?.string().required(t("validation_required")),
    adresse: yup?.string().required(t("validation_required")),
    ville: yup?.string().required(t("validation_required")),
    code_postal: yup?.string().required(t("validation_required")),
    cellulaire: yup?.string().min(8, t("forms.validation.8_char_min")).required(t("validation_required")),
    telephone: yup?.string().min(8, t("forms.validation.8_char_min")).required(t("validation_required")),
    courriel: yup?.string().email(t("forms.validation.email")).required(t("validation_required")),
    payable_first_name: yup?.string().required(t("validation_required")),
    payable_last_name: yup?.string().required(t("validation_required")),
    payable_email: yup?.string().email(t("forms.validation.email")).required(t("validation_required")),
    utilisateur: yup?.string().required(t("validation_required")),
    mot_de_passe: yup?.string().min(8, t("forms.validation.8_char_min")).required(t("validation_required")),
    bd: yup?.object({
      id: yup?.string().required(t("validation_required")),
    }),
  });

  useEffect(() => {
    if (limit?.state === false) {
      handleGetAllBanners();
    }
  }, [limit]);
  useEffect(() => {
    if (limit?.state === false) {
      handleGetAllDbs();
    }
  }, [limitDbs]);
  useEffect(() => {
    Api.get(Urls?.GET_BANNIERES, {
      headers: { "Content-Type": "application/json", authorization: `Bearer ${access_token}` },
      params: {
        offset: 0,
        limit: limit?.number,
      },
    })

      .then((res) => {
        setData((data) => {
          return res?.data?.results;
        });
        setLimit({ state: false, number: res?.data?.count });
        setLoading(false);
      })
      .catch((err) => {
        setError(err?.response?.data?.details);
        setLoading(false);
      });
  }, []);
  useEffect(() => {
    if (franchise?.id) {
      Api.get(Urls?.GetDbsByFrID(franchise?.id), {
        headers: { "Content-Type": "application/json", authorization: `Bearer ${access_token}` },
        params: {
          offset: 0,
          limit: limitDbs?.number,
          has_manager: false,
          is_master: false,
        },
      })

        .then((res) => {
          setBds((data) => {
            return res?.data?.results;
          });
          setLimitDbs({ state: false, number: res?.data?.count });
          setLoading(false);
        })
        .catch((err) => {
          setError(err?.response?.data?.details);
          setLoading(false);
        });
    }
  }, [franchise]);
  //HANDLE SBUMIT CREATE MANAGER
  const handleSubmit = (values) => {
    setError(null);
    Api.post(
      Urls.ADD_MANAGERS,
      {
        store_manager_credentials: {
          username: values?.utilisateur,
          password: values?.mot_de_passe,
          email: values?.courriel,
        },
        store_manager_profile: {
          store_manager_code: values?.code_marchand,
          enterprise_name: values?.entreprise,
          company_manager_first_name: values?.responsable_first_name,
          company_manager_last_name: values?.responsable_last_name,
          address: values?.adresse,
          city: values?.ville,
          postal_code: values?.code_postal,
          phone_number: values?.telephone,
          cellular_number: values?.cellulaire,
          payable_responsible_first_name: values?.payable_first_name,
          payable_responsible_last_name: values?.payable_last_name,
          payable_email: values?.payable_email,
          product_db_id: values?.bd?.id,
          franchise_id: values?.banniere?.id,
        },
      },
      {
        headers: { "Content-Type": "application/json", "Accept-Language": lang + "-" + lang, Authorization: `Bearer ${access_token}` },
      }
    )
      .then((res) => {
        setSuccess(t("forms.success.add"));
        setTimeout(() => {
          setSuccess("");
        }, 3000);
      })
      .catch((err) => {
        handleError(err?.response?.data);
      });
  };
  //HANDLE ERROR
  function handleError(error) {
    setError({
      store_manager_credentials: {
        username: error?.store_manager_credentials?.username,
        password: error?.store_manager_credentials?.password,
        email: error?.store_manager_credentials?.email,
      },
      store_manager_profile: {
        store_manager_code: error?.store_manager_profile?.store_manager_code,
        enterprise_name: error?.store_manager_profile?.enterprise_name,
        company_manager_first_name: error?.store_manager_profile?.company_manager_first_name,
        company_manager_last_name: error?.store_manager_profile?.company_manager_last_name,
        address: error?.store_manager_profile?.address,
        city: error?.store_manager_profile?.city,
        postal_code: error?.store_manager_profile?.postal_code,
        phone_number: error?.store_manager_profile?.phone_number,
        cellular_number: error?.store_manager_profile?.cellular_number,
        payable_responsible_first_name: error?.store_manager_profile?.payable_responsible_first_name,
        payable_responsible_last_name: error?.store_manager_profile?.payable_responsible_last_name,
        payable_email: error?.store_manager_profile?.payable_email,
        product_bd_id: error?.store_manager_profile?.product_bd_id,
        franchise_id: error?.store_manager_profile?.franchise_id,
      },
    });
  }
  const handleGetAllBanners = () => {
    Api.get(Urls?.GET_BANNIERES, {
      headers: { "Content-Type": "application/json", authorization: `Bearer ${access_token}` },
      params: {
        offset: 0,
        limit: limit?.number,
      },
    })

      .then((res) => {
        setData((data) => {
          return res?.data?.results;
        });
      })
      .catch((err) => {
        setError(err?.response?.data?.details);
      });
  };
  const handleGetAllDbs = () => {
    Api.get(Urls?.GetDbsByFrID(franchise?.id), {
      headers: { "Content-Type": "application/json", authorization: `Bearer ${access_token}` },
      params: {
        offset: 0,
        limit: limitDbs?.number,
        has_manager: false,
        is_master: false,
      },
    })

      .then((res) => {
        setBds((data) => {
          return res?.data?.results;
        });
        setLoading(false);
      })
      .catch((err) => {
        setError(err?.response?.data?.details);

        setLoading(false);
      });
  };

  return (
    <Box>
      {loading && <Loading />}
      {!loading && (
        <Formik initialValues={initial_values} validationSchema={validationSchema} enableReinitialize onSubmit={handleSubmit}>
          {({ errors, values, setFieldValue }) => (
            <Form>
              <Box maxWidth="500px" display="flex" flexDirection="column" gap="16px">
                <Box>
                  <Box sx={{ flexDirection: { xs: "column", sm: "column", md: "row", lg: "row" } }} display="flex" alignItems="center" gap="24px">
                    <Box flex={1}>
                      <Typography variant="text_md_white" fontWeight="600" color={colors?.main}>
                        {t("forms.labels.banniere")}
                      </Typography>
                    </Box>
                    <Box>
                      <Autocomplete
                        sx={{ minWidth: "262px" }}
                        value={values.banniere}
                        options={data}
                        getOptionLabel={(e) => e?.name}
                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                        onChange={(event, value) => {
                          if (value !== null) {
                            setFieldValue("banniere", value);
                            setFranchise(value);
                            setFieldValue("bd", { name: "", id: "" });
                          } else {
                            setFieldValue("banniere", null);
                          }
                        }}
                        renderInput={(params) => <TextField fullWidth {...params} name="autocomplete" placeholder={t("forms.labels.banniere")} />}
                      />
                      <ErrorMessage name="banniere.id" component={FormikErrorText} color={colors.main} width="250px" />
                    </Box>
                  </Box>
                </Box>
                <Box>
                  <Box sx={{ flexDirection: { xs: "column", sm: "column", md: "row", lg: "row" } }} display="flex" alignItems="center" gap="24px">
                    <Box flex={1}>
                      <Typography variant="text_md_white" fontWeight="600" color={colors?.main}>
                        {t("forms.labels.code_marchand")}
                      </Typography>
                    </Box>
                    <Box>
                      <Field name="code_marchand" type="input" placeholder={t("forms.labels.code_marchand")} as={TextField} />
                      <ErrorMessage name="code_marchand" component={FormikErrorText} color={colors.main} width="250px" />
                    </Box>
                  </Box>
                </Box>
                <Box>
                  <Box sx={{ flexDirection: { xs: "column", sm: "column", md: "row", lg: "row" } }} display="flex" alignItems="center" gap="24px">
                    <Box flex={1}>
                      <Typography variant="text_md_white" fontWeight="600" color={colors?.main}>
                        {t("forms.labels.entreprise")}
                      </Typography>
                    </Box>
                    <Box>
                      <Field name="entreprise" type="input" placeholder={t("forms.labels.entreprise")} as={TextField} />
                      <ErrorMessage name="entreprise" component={FormikErrorText} color={colors.main} width="250px" />
                    </Box>
                  </Box>
                </Box>
                <Box>
                  <Box sx={{ flexDirection: { xs: "column", sm: "column", md: "row", lg: "row" } }} display="flex" alignItems="center" gap="24px">
                    <Box flex={1}>
                      <Typography variant="text_md_white" fontWeight="600" color={colors?.main}>
                        {t("forms.labels.responsable")} {t("forms.labels.nom")}
                      </Typography>
                    </Box>
                    <Box>
                      <Field name="responsable_last_name" type="input" placeholder={t("forms.labels.responsable")} as={TextField} />
                      <ErrorMessage name="responsable_last_name" component={FormikErrorText} color={colors.main} width="250px" />
                    </Box>
                  </Box>
                </Box>
                <Box>
                  <Box sx={{ flexDirection: { xs: "column", sm: "column", md: "row", lg: "row" } }} display="flex" alignItems="center" gap="24px">
                    <Box flex={1}>
                      <Typography variant="text_md_white" fontWeight="600" color={colors?.main}>
                        {t("forms.labels.responsable")} {t("forms.labels.prenom")}
                      </Typography>
                    </Box>
                    <Box>
                      <Field name="responsable_first_name" type="input" placeholder={t("forms.labels.responsable")} as={TextField} />
                      <ErrorMessage name="responsable_first_name" component={FormikErrorText} color={colors.main} width="250px" />
                    </Box>
                  </Box>
                </Box>
                <Box>
                  <Box sx={{ flexDirection: { xs: "column", sm: "column", md: "row", lg: "row" } }} display="flex" alignItems="center" gap="24px">
                    <Box flex={1}>
                      <Typography variant="text_md_white" fontWeight="600" color={colors?.main}>
                        {t("forms.labels.adresse")}
                      </Typography>
                    </Box>
                    <Box>
                      <Field name="adresse" type="input" placeholder={t("forms.labels.adresse")} as={TextField} />
                      <ErrorMessage name="adresse" component={FormikErrorText} color={colors.main} width="250px" />
                    </Box>
                  </Box>
                </Box>
                <Box>
                  <Box sx={{ flexDirection: { xs: "column", sm: "column", md: "row", lg: "row" } }} display="flex" type="input" alignItems="center" gap="24px">
                    <Box flex={1}>
                      <Typography variant="text_md_white" fontWeight="600" color={colors?.main}>
                        {t("forms.labels.ville")}
                      </Typography>
                    </Box>
                    <Box>
                      <Field name="ville" placeholder={t("forms.labels.ville")} as={TextField} />
                      <ErrorMessage name="ville" component={FormikErrorText} color={colors.main} width="250px" />
                    </Box>
                  </Box>
                </Box>
                <Box>
                  <Box sx={{ flexDirection: { xs: "column", sm: "column", md: "row", lg: "row" } }} display="flex" type="input" alignItems="center" gap="24px">
                    <Box flex={1}>
                      <Typography variant="text_md_white" fontWeight="600" color={colors?.main}>
                        {t("forms.labels.code_postal")}
                      </Typography>
                    </Box>
                    <Box>
                      <Field name="code_postal" placeholder={t("forms.labels.code_postal")} as={TextField} />
                      <ErrorMessage name="code_postal" component={FormikErrorText} color={colors.main} width="250px" />
                    </Box>
                  </Box>
                </Box>
                <Box>
                  <Box sx={{ flexDirection: { xs: "column", sm: "column", md: "row", lg: "row" } }} display="flex" type="input" alignItems="center" gap="24px">
                    <Box flex={1}>
                      <Typography variant="text_md_white" fontWeight="600" color={colors?.main}>
                        {t("forms.labels.cellulaire")}
                      </Typography>
                    </Box>
                    <Box>
                      <Field name="cellulaire" type="input" placeholder={t("forms.labels.cellulaire")} as={TextField} />
                      <ErrorMessage name="cellulaire" component={FormikErrorText} color={colors.main} width="250px" />
                    </Box>
                  </Box>
                </Box>
                <Box>
                  <Box sx={{ flexDirection: { xs: "column", sm: "column", md: "row", lg: "row" } }} display="flex" type="input" alignItems="center" gap="24px">
                    <Box flex={1}>
                      <Typography variant="text_md_white" fontWeight="600" color={colors?.main}>
                        {t("forms.labels.telephone")}
                      </Typography>
                    </Box>
                    <Box>
                      <Field name="telephone" type="input" placeholder={t("forms.labels.telephone")} as={TextField} />
                      <ErrorMessage name="telephone" component={FormikErrorText} color={colors.main} width="250px" />
                    </Box>
                  </Box>
                </Box>
                <Box>
                  <Box sx={{ flexDirection: { xs: "column", sm: "column", md: "row", lg: "row" } }} display="flex" alignItems="center" gap="24px">
                    <Box flex={1}>
                      <Typography variant="text_md_white" fontWeight="600" color={colors?.main}>
                        {t("forms.labels.courriel")}
                      </Typography>
                    </Box>
                    <Box>
                      <Field type="input" name="courriel" placeholder={t("forms.labels.courriel")} as={TextField} />
                      <ErrorMessage name="courriel" component={FormikErrorText} color={colors.main} width="250px" />
                    </Box>
                  </Box>
                </Box>
                <Box>
                  <Box sx={{ flexDirection: { xs: "column", sm: "column", md: "row", lg: "row" } }} display="flex" alignItems="center" gap="24px">
                    <Box flex={1}>
                      <Typography variant="text_md_white" fontWeight="600" color={colors?.main}>
                        {t("forms.labels.payable_responsable")} {t("forms.labels.nom")}
                      </Typography>
                    </Box>
                    <Box>
                      <Field type="input" name="payable_last_name" placeholder={t("forms.labels.payable_responsable")} as={TextField} />
                      <ErrorMessage name="payable_last_name" component={FormikErrorText} color={colors.main} width="250px" />
                    </Box>
                  </Box>
                </Box>
                <Box>
                  <Box sx={{ flexDirection: { xs: "column", sm: "column", md: "row", lg: "row" } }} display="flex" alignItems="center" gap="24px">
                    <Box flex={1}>
                      <Typography variant="text_md_white" fontWeight="600" color={colors?.main}>
                        {t("forms.labels.payable_responsable")} {t("forms.labels.prenom")}
                      </Typography>
                    </Box>
                    <Box>
                      <Field type="input" name="payable_first_name" placeholder={t("forms.labels.payable_responsable")} as={TextField} />
                      <ErrorMessage name="payable_first_name" component={FormikErrorText} color={colors.main} width="250px" />
                    </Box>
                  </Box>
                </Box>
                <Box>
                  <Box sx={{ flexDirection: { xs: "column", sm: "column", md: "row", lg: "row" } }} display="flex" alignItems="center" gap="24px">
                    <Box flex={1}>
                      <Typography variant="text_md_white" fontWeight="600" color={colors?.main}>
                        {t("forms.labels.payable_email")}
                      </Typography>
                    </Box>
                    <Box>
                      <Field type="input" name="payable_email" placeholder={t("forms.labels.payable_email")} as={TextField} />
                      <ErrorMessage name="payable_email" component={FormikErrorText} color={colors.main} width="250px" />
                    </Box>
                  </Box>
                </Box>
                <Box>
                  <Box sx={{ flexDirection: { xs: "column", sm: "column", md: "row", lg: "row" } }} display="flex" alignItems="center" gap="24px">
                    <Box flex={1}>
                      <Typography variant="text_md_white" fontWeight="600" color={colors?.main}>
                        {t("forms.labels.utilisateur")}
                      </Typography>
                    </Box>
                    <Box>
                      <Field name="utilisateur" placeholder={t("forms.labels.utilisateur")} as={TextField} />
                      <ErrorMessage name="utilisateur" component={FormikErrorText} color={colors.main} width="250px" />
                    </Box>
                  </Box>
                </Box>
                <Box>
                  <Box sx={{ flexDirection: { xs: "column", sm: "column", md: "row", lg: "row" } }} display="flex" alignItems="center" gap="24px">
                    <Box flex={1}>
                      <Typography variant="text_md_white" fontWeight="600" color={colors?.main}>
                        {t("forms.labels.mot_de_passe")}
                      </Typography>
                    </Box>
                    <Box>
                      <Field name="mot_de_passe" placeholder={t("forms.labels.mot_de_passe")} as={TextField} />
                      <ErrorMessage name="mot_de_passe" component={FormikErrorText} color={colors.main} width="250px" />
                    </Box>
                  </Box>
                </Box>
                <Box>
                  <Box sx={{ flexDirection: { xs: "column", sm: "column", md: "row", lg: "row" } }} display="flex" alignItems="center" gap="24px">
                    <Box flex={1}>
                      <Typography variant="text_md_white" fontWeight="600" color={colors?.main}>
                        {t("forms.labels.bd")}
                      </Typography>
                    </Box>
                    <Box>
                      <Autocomplete
                        sx={{ minWidth: "262px" }}
                        value={values.bd}
                        options={bds}
                        getOptionLabel={(e) => e?.name}
                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                        onChange={(event, value) => {
                          if (value !== null) {
                            setFieldValue("bd", value);
                          } else {
                            setFieldValue("bd", null);
                          }
                        }}
                        renderInput={(params) => <TextField fullWidth {...params} name="autocomplete" placeholder={t("forms.labels.bd")} />}
                      />
                      <ErrorMessage name="bd.id" component={FormikErrorText} color={colors.main} width="250px" />
                    </Box>
                  </Box>
                </Box>
                {success && <Alert severity="success">{success}</Alert>}
                {error && (
                  <Alert severity="error">
                    <Box>
                      <List>
                        {error?.store_manager_credentials?.username && (
                          <ListItem>
                            {t("forms.labels.utilisateur")} : {error?.store_manager_credentials?.username}
                          </ListItem>
                        )}
                        {error?.store_manager_credentials?.password && (
                          <ListItem>
                            {t("forms.labels.mot_de_passe")} : {error?.store_manager_credentials?.password}
                          </ListItem>
                        )}
                        {error?.store_manager_credentials?.email && (
                          <ListItem>
                            {t("forms.labels.courriel")} : {error?.store_manager_credentials?.email}
                          </ListItem>
                        )}
                        {error?.store_manager_profile?.franchise_id && (
                          <ListItem>
                            {t("forms.labels.banniere")} : {error?.store_manager_profile?.franchise_id}
                          </ListItem>
                        )}
                        {error?.store_manager_profile?.store_manager_code && (
                          <ListItem>
                            {t("forms.labels.code_marchand")} : {error?.store_manager_profile?.store_manager_code}
                          </ListItem>
                        )}
                        {error?.store_manager_profile?.enterprise_name && (
                          <ListItem>
                            {t("forms.labels.entreprise")} : {error?.store_manager_profile?.enterprise_name}
                          </ListItem>
                        )}
                        {error?.store_manager_profile?.company_manager_first_name && (
                          <ListItem>
                            {t("forms.labels.responsable")} : {error?.store_manager_profile?.company_manager_first_name}
                          </ListItem>
                        )}
                        {error?.store_manager_profile?.company_manager_last_name && (
                          <ListItem>
                            {t("forms.labels.responsable")} : {error?.store_manager_profile?.company_manager_last_name}
                          </ListItem>
                        )}
                        {error?.store_manager_profile?.address && (
                          <ListItem>
                            {t("forms.labels.adresse")} : {error?.store_manager_profile?.address}
                          </ListItem>
                        )}
                        {error?.store_manager_profile?.city && (
                          <ListItem>
                            {t("forms.labels.ville")} : {error?.store_manager_profile?.city}
                          </ListItem>
                        )}
                        {error?.store_manager_profile?.postal_code && (
                          <ListItem>
                            {t("forms.labels.code_postal")} : {error?.store_manager_profile?.postal_code}
                          </ListItem>
                        )}
                        {error?.store_manager_profile?.phone_number && (
                          <ListItem>
                            {t("forms.labels.telephone")} : {error?.store_manager_profile?.phone_number}
                          </ListItem>
                        )}
                        {error?.store_manager_profile?.cellular_number && (
                          <ListItem>
                            {t("forms.labels.cellulaire")} : {error?.store_manager_profile?.cellular_number}
                          </ListItem>
                        )}
                        {error?.store_manager_profile?.payable_responsible_first_name && (
                          <ListItem>
                            {t("forms.labels.payable_responsable")} : {error?.store_manager_profile?.payable_responsible_first_name}
                          </ListItem>
                        )}
                        {error?.store_manager_profile?.payable_responsible_last_name && (
                          <ListItem>
                            {t("forms.labels.payable_responsable")} : {error?.store_manager_profile?.payable_responsible_last_name}
                          </ListItem>
                        )}
                        {error?.store_manager_profile?.payable_email && (
                          <ListItem>
                            {t("forms.labels.payable_email")} : {error?.store_manager_profile?.payable_email}
                          </ListItem>
                        )}

                        {error?.store_manager_profile?.product_bd_id && (
                          <ListItem>
                            {t("forms.labels.bd")} : {error?.store_manager_profile?.product_bd_id}
                          </ListItem>
                        )}
                      </List>
                    </Box>
                  </Alert>
                )}
                <Box>
                  <Button type="submit" variant="primary">
                    {t("forms.submit.save")}
                  </Button>
                </Box>
              </Box>
            </Form>
          )}
        </Formik>
      )}
    </Box>
  );
};
export default AjoutMarchand;
